import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function Reports() {
  const [rows, setRows] = useState(null);
  useEffect(() => {
    fetch(`${API}/public/reports`).then(r => r.json())
      .then(d => setRows(d.reports || []))
      .catch(() => setRows([]));
  }, []);
  return (
    <section data-testid="reports-section" className="space-y-6">
      <h1 className="hs-display text-3xl md:text-4xl">Reports</h1>
      <p className="text-muted max-w-2xl">
        Observatory reports. Confirmed-only. Evidence redacted. Response signed by the
        HerdSafe ed25519 key.
      </p>
      {rows === null && <div data-testid="reports-loading" className="text-sm text-muted">loading…</div>}
      {rows && rows.length === 0 && (
        <div data-testid="reports-empty" className="hs-card border-dashed text-sm text-muted">
          No reports have been published yet.
        </div>
      )}
      <ul className="space-y-3">
        {(rows || []).map(r => (
          <li key={r.id} data-testid={`report-row-${r.period}`}
              className="hs-card hover:border-accent transition-colors">
            <Link to={`/reports/${r.period}`} className="block">
              <div className="flex items-baseline gap-3">
                <h2 className="text-xl text-fg">{r.period}</h2>
                <span className="text-xs text-muted">published {r.published_at?.slice(0, 10)}</span>
              </div>
              <p className="mt-2 text-sm text-muted">{r.summary || "(no summary)"}</p>
            </Link>
          </li>
        ))}
      </ul>
    </section>
  );
}
